<template>
    <div class="row" v-if="(Order.IsExtra == false) || (Order.isExtra == false)">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="order-title">
                Patient Demographic
            </div>
            <p>Please enter as much of the following information as possible</p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
            <div class="row no-gutters order-div">
                <div class="col-lg-12 col-md-12 col-xs-12">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>Patient DOB</label>
                                <!--<datepicker :disabled="datepickerState.disabled"  :format="'MM/dd/yyyy'" v-bind:class="{ error_field: ValidationResult.OrderPatDOBAge }" :bootstrap-styling="true" name="uniquename"></datepicker>-->
                                <input v-on:keyup="ComputeAge(Order.PatDOB)" v-mask="'##/##/####'" v-model="Order.PatDOB" class="form-control" v-bind:class="{ error_field: ValidationResult.OrderPatDOBAge }" type="text" placeholder="MM/DD/YYYY" />
                                <p class="error-message" v-if="ValidationResult.OrderPatDOBAge">{{ValidationResult.OrderPatDOBAge}}</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>Age*</label>
                                <td>
                                    <input v-model="Order.Age" min="0" type="number" class="form-control" v-bind:class="{ error_field: ValidationResult.OrderAge }">
                                    <!--<input minSize = "1" v-model="Order.Age" type="number" class="form-control" v-bind:class="{ error_field: ValidationResult.OrderAge }">-->
                                    <!--<rx-input minSize="1" maxSize="150" stepSize="1" v-bind:class="{ error_field: ValidationResult.OrderAge }" v-model="Order.Age"></rx-input> -->
                                </td>
                                <p class="error-message" v-if="ValidationResult.OrderAge">{{ValidationResult.OrderAge}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-group order-div">
                <label>Patient Gender</label>
                <select v-model="Order.PatGender" class="form-control" style="height: 36.5px;">
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                </select>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-group order-div">
                <label>Patient Ethnicity</label>
                <select v-model="Order.PatEthnicity" class="form-control" style="height: 36.5px;">
                    <option v-for="(value, key) in Ethnicity" v-bind:value="key">{{key}}</option>
                </select>
            </div>
        </div>
        <div v-if="(Order.ShowExtraStudentFields == true)" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-check order-div padding-left">
                <label class="form-check-label">Ever Worn Glasses? </label>
                <br>
                <label class="radio-inline form-check-label input-space-right"><input v-on:change="ComputeFirstTimeWear(Order.EverWornGlasses)" v-model="Order.EverWornGlasses" type="radio" name="EverWornGlasses" value="Yes"> Yes</label>
                <label class="radio-inline form-check-label input-space-right"><input v-on:change="ComputeFirstTimeWear(Order.EverWornGlasses)" v-model="Order.EverWornGlasses" type="radio" name="EverWornGlasses" value="No"> No</label>
                <label class="radio-inline form-check-label input-space-right"><input v-on:change="ComputeFirstTimeWear(Order.EverWornGlasses)" v-model="Order.EverWornGlasses" type="radio" name="EverWornGlasses" value="Unsure"> Unsure</label>
            </div>
        </div>
        <div v-if="!Order.IsExamOnly && !Order.ShowExtraStudentFields" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-check order-div padding-left">
                <label class="form-check-label">First Time Glasses Wearer</label>
                <br>
                <label class="radio-inline form-check-label input-space-right"><input v-model="Order.PatIsFirstTimeGlassesWearer" type="radio" name="PatIsFirstTimeGlassesWearer" value="Yes"> Yes</label>
                <label class="radio-inline form-check-label input-space-right"><input v-model="Order.PatIsFirstTimeGlassesWearer" type="radio" name="PatIsFirstTimeGlassesWearer" value="No"> No</label>
                <label class="radio-inline form-check-label input-space-right"><input v-model="Order.PatIsFirstTimeGlassesWearer" type="radio" name="PatIsFirstTimeGlassesWearer" value="Unsure"> Unsure</label>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-check order-div padding-left">
                <label class="form-check-label">First Time Eye Exam</label>
                <br>
                <label class="radio-inline form-check-label input-space-right"><input v-model="Order.PatIsFirstTimeEyeExam" type="radio" name="PatIsFirstTimeEyeExam" value="Yes"> Yes</label>
                <label class="radio-inline form-check-label input-space-right"><input v-model="Order.PatIsFirstTimeEyeExam" type="radio" name="PatIsFirstTimeEyeExam" value="No"> No</label>
                <label class="radio-inline form-check-label input-space-right"><input v-model="Order.PatIsFirstTimeEyeExam" type="radio" name="PatIsFirstTimeEyeExam" value="Unsure"> Unsure</label>
            </div>
        </div>
    </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import RxInput from './RxInput.vue'
import { mask } from "vue-the-mask";
export default {
  props: ["Order", "Ethnicity", "ValidationResult"],
  components: { Datepicker, RxInput },
  directives: { mask },
  data() {
    return {
      dob: null,
      isOrderRefPO: null,
      max: 15,
      datepickerState: {
        disabled: {
          from: new Date() // Disable all dates up to specific date
        }
      }
    };
  },
  computed: {
    age: function() {}
  },
  methods: {
    ComputeAge(ageval) {
      if (this.Order.PatDOB) {
        if (ageval.length >= 10) {
          var dateNow = new Date();
          var dateAgeVal = new Date(ageval);
          var age = dateNow - dateAgeVal;
          var ageDate = new Date(age);
          if (dateNow > dateAgeVal) {
            var computedAge = Math.abs(ageDate.getUTCFullYear() - 1970);
            this.Order.Age = computedAge.toString();
          }
          //return Math.abs(ageDate.getUTCFullYear() - 1970);
        }
      }
    },
    ComputeFirstTimeWear(EverWornVal) {
        if(this.Order.IsExamOnly == false && this.Order.EverWornGlasses == 'Yes'){this.Order.PatIsFirstTimeGlassesWearer = 'No'}
        else if(this.Order.IsExamOnly == false && this.Order.EverWornGlasses == 'No'){this.Order.PatIsFirstTimeGlassesWearer = 'Yes'}
        else if(this.Order.EverWornGlasses == 'Unsure'){this.Order.PatIsFirstTimeGlassesWearer = 'Unsure'};
    }
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// PatientInformation.vue?97336b5e